<template>
	<section class="container margin-auto margin-both-lg">
		<template>
			<transition v-if="data.email && data.form" name="opacity">
				<GravityFormPopup
					v-if="showForm"
					:fields="{ clinic_address: data.email }"
					:title="data.popup_title || ''"
					:content="data.popup_description || ''"
					:form="Number(data.form)"
					@close="formIsClosed"
				/>
			</transition>
		</template>
		<div class="inner box-shadow">
			<div class="heading" v-if="data.module_title">
				<h2 class="module-title" v-if="data.module_title">{{ data.module_title }}</h2>
				<ColorLink
					v-if="data.map_link"
					:link="data.map_link"
					:color="data.link_color.name"
					:outlined="data.link_color.name !== 'red'"
				/>
			</div>
			<div v-else class="heading-infos padding-lg">
				<div class="logo-row margin-bottom-lg">
					<WpImage :image="data.logo" v-if="data.logo" />
					<Button @click.native="triggerFormPopup" v-if="data.form" type="red" :outlined="false">
						Ta kontakt
					</Button>
				</div>
				<div class="infos">
					<a class="item phone" :href="'tel:' + data.phone.phoneFormat()" v-if="data.phone">
						<svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
							<defs />
							<g fill="none">
								<path d="M-150-200h1440v900H-150z" />
								<g transform="translate(-50 -175)">
									<rect width="1240" height="850" rx="10" />
									<g transform="translate(50 175)">
										<circle fill="#FFF" cx="25" cy="25" r="25" />
										<path
											d="M42.675 7.32C32.91-2.442 17.081-2.44 7.32 7.325c-9.762 9.765-9.76 25.594.005 35.355 9.765 9.762 25.594 9.76 35.355-.005a25 25 0 00-.005-35.355zm-4.813 27.505l-.004.003v-.008l-1.266 1.258a6.667 6.667 0 01-6.292 1.8 22.152 22.152 0 01-6.433-2.883 29.724 29.724 0 01-5.075-4.092 29.952 29.952 0 01-3.792-4.6 23.33 23.33 0 01-2.85-5.767 6.666 6.666 0 011.667-6.808l1.483-1.483a1.058 1.058 0 011.497-.004l.003.004 4.683 4.683a1.058 1.058 0 010 1.5l-2.75 2.75c-.789.78-.888 2.02-.233 2.917a32.161 32.161 0 003.292 3.841 31.964 31.964 0 004.333 3.642c.895.625 2.109.52 2.883-.25l2.659-2.7a1.058 1.058 0 011.5 0l4.691 4.7c.415.412.416 1.082.004 1.497z"
											fill="#EF9400"
										/>
									</g>
								</g>
							</g>
						</svg>
						<span>{{ data.phone }}</span>
					</a>
					<a class="item website" rel="noopener" :href="data.website" v-if="data.website">
						<svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
							<defs />
							<g fill="none" fill-rule="evenodd">
								<path d="M-770-200H670v900H-770z" />
								<g transform="translate(-670 -175)">
									<rect width="1240" height="850" rx="10" />
									<g transform="translate(670 175)">
										<circle fill="#B90F31" cx="25" cy="25" r="25" />
										<path
											fill="#FFF"
											fill-rule="nonzero"
											d="M32.968 14.95h-4.096v1.746l4.096 3.333zM32.968 27.929v-1.732l-4.096-3.338-4.373-3.563-8.469 6.901v9.419h5.339v-9.275h6.26v9.275h5.339z"
										/>
										<path
											fill="#FFF"
											fill-rule="nonzero"
											d="M16.03 25.307l8.469-6.902 4.373 3.564 4.096 3.338 1.879 1.531 2.151-2.641-4.03-3.278-4.096-3.333-4.373-3.557L12 24.197l2.152 2.641z"
										/>
									</g>
								</g>
							</g>
						</svg>
						<span>Se nettside</span>
					</a>

					<a class="item email" :href="'mailto:' + data.email" v-if="data.email">
						<svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
							<defs />
							<g fill="none" fill-rule="evenodd">
								<path d="M-150-275h1440v900H-150z" />
								<g transform="translate(-50 -250)">
									<rect width="1240" height="850" rx="10" />
									<g mask="url(#mask-2)">
										<g transform="translate(50 250)">
											<circle fill="#FFF" cx="25" cy="25" r="25" />
											<path
												d="M25 0C11.193 0 0 11.193 0 25s11.193 25 25 25 25-11.193 25-25S38.807 0 25 0zm11.263 13.889L24.991 22.8 13.35 13.89h22.912zm1.16 22.222H12.19V17.653l11.631 8.821c.312.239.773.358 1.145.358.38 0 .711-.125 1.027-.374l11.429-9.092v18.745z"
												fill="#80BA26"
												fill-rule="nonzero"
											/>
										</g>
									</g>
								</g>
							</g>
						</svg>
						<span>{{ data.email }}</span>
					</a>

					<span class="item address" v-if="data.address">
						<svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
							<defs />
							<g fill="none" fill-rule="evenodd">
								<path d="M-770-275H670v900H-770z" />
								<g transform="translate(-670 -250)">
									<rect width="1240" height="850" rx="10" />
									<g mask="url(#mask-2)">
										<g transform="translate(670 250)">
											<circle fill="#96A8D5" cx="25" cy="25" r="25" />
											<path
												d="M25 11c-5.514 0-10 4.486-10 10 0 5.308 9.073 17.709 9.46 18.234l.36.49a.223.223 0 00.36 0l.36-.49C25.928 38.709 35 26.308 35 21c0-5.514-4.486-10-10-10zm0 6.418A3.586 3.586 0 0128.582 21 3.586 3.586 0 0125 24.582 3.587 3.587 0 0121.417 21 3.586 3.586 0 0125 17.418z"
												fill="#FFF"
												fill-rule="nonzero"
											/>
										</g>
									</g>
								</g>
							</g>
						</svg>
						<span>{{ data.address }}</span>
					</span>
				</div>
			</div>
			<div class="frame-container" v-html="mapFrame"></div>
		</div>
	</section>
</template>

<script>
import ColorLink from '@/components/elements/ColorLink'
import WpImage from '@/components/elements/WpImage'
import Button from '@/components/elements/Button'
import GravityFormPopup from '@/components/parts/GravityFormPopup'

export default {
	props: ['data'],
	data() {
		return {
			showForm: false,
			allowReopenPopup: true,
		}
	},
	components: {
		ColorLink,
		Button,
		WpImage,
		GravityFormPopup,
	},
	computed: {
		mapFrame() {
			if (this.data && this.data.website) {
				return this.data.iframe_map
			} else {
				return this.data.google_map_iframe
			}
		},
	},
	methods: {
		triggerFormPopup() {
			if (this.allowReopenPopup) {
				this.showForm = true
				this.allowReopenPopup = false
			}
		},
		formIsClosed() {
			this.showForm = false
			setTimeout(() => {
				this.allowReopenPopup = true
			}, 400)
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';
.module-map {
	.heading {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 25px;
		@include mquery($tablet) {
		}
		@include mquery($phone) {
			display: block;
			.color-link {
				margin-top: 15px;
				display: block;
				width: 100%;
			}
		}
	}
	.heading-infos {
		.infos {
			display: flex;
			flex-wrap: wrap;
			margin-bottom: -25px;

			.item {
				width: 100%;
				max-width: 50%;
				min-width: 50%;
				margin-bottom: 25px;
				display: flex;
				align-items: center;
				@include mquery($phone) {
					max-width: 100%;
					min-width: 100%;
					margin-bottom: 15px;
					span {
						display: block;
						margin-left: 15px;
					}
				}
			}
			svg {
				margin-right: 25px;
				@include mquery($phone) {
					height: 30px;
					width: 30px;
					margin-right: 0px;
				}
			}
			a {
				text-decoration: none;
			}
		}
	}
	.logo-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		@include mquery($phone) {
			display: block;
			.fill-button {
				margin-top: 15px;
			}
		}
		img {
			max-height: 100px;
			width: auto;
			@include mquery($tablet) {
				max-height: 70px;
			}
			@include mquery($phone) {
				max-height: 50px;
			}
		}
	}
	.module-title {
		margin: 0;
	}
	.inner {
		background-color: var(--light);
	}
	.frame-container {
		height: 0;
		padding-bottom: 56.3%;
		overflow: hidden;
		position: relative;
		min-height: 300px;
		background-color: var(--light);
		iframe {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			width: 100%;
			height: 100%;
		}
	}
}
</style>
